import { render, staticRenderFns } from "./BillWriteoff.vue?vue&type=template&id=2219cc8c&scoped=true&"
import script from "./BillWriteoff.vue?vue&type=script&lang=js&"
export * from "./BillWriteoff.vue?vue&type=script&lang=js&"
import style0 from "./BillWriteoff.vue?vue&type=style&index=0&id=2219cc8c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2219cc8c",
  null
  
)

export default component.exports